




















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { OrganisationInteraction as Interaction } from '@/api/generated'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'

@Component({
  name: 'organisation-interaction',
  components: { RespondecoResponsiveImage },
})
export default class OrganisationInteraction extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly interaction!: Interaction
}
